import {
  Home,
  Circle,
  ShoppingCart,
  Box,
  Package,
  Archive
} from 'react-feather'

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // {
  // id: "Misc",
  // title: "Home",
  // icon: <Home size={20} />,
  // children: [
  {
    id: 'Intro-legacy',
    title: 'Introduction',
    icon: <Circle size={12} />,
    navLink: '/intro',
    action: 'true',
    resource: 'brands_free_navigation'
  }
  // {
  //   id: "Intro",
  //   title: "Introduction",
  //   icon: <Circle size={12} />,
  //   action: "true",
  //   resource: "brands_v2",
  //   externalLink: true,
  //   newTab: true,
  //   navLink: "https://beuni.com.br/onboarding-plataforma/",
  // },
  // {
  //   id: 'Pricing',
  //   title: 'Planos',
  //   icon: <Circle size={20} />,
  //   navLink: '/pricing',
  //   action: 'true',
  //   resource: 'commom'
  // },

  // {
  //   id: 'Faq',
  //   title: 'Perguntas frequentes',
  //   icon: <Circle size={12} />,
  //   navLink: '/faq',
  //   action: 'true',
  //   resource: 'brands_v2'
  // }
  // {
  //   id: 'knowledgeBase',
  //   title: 'Banco de conhecimento',
  //   icon: <Circle size={12} />,
  //   navLink: '/pages/knowledge-base',
  //   parentOf: ['/pages/knowledge-base/category/questions', '/pages/knowledge-base/category'],
  //   action: 'true',
  //   resource: 'commom'
  // },
  //  ]
  // },
]
